<script setup lang="ts">
import { getAlmInfo } from "@/backend/read/BackendReader";
import { cardKey } from "@/components/StickyNote/injectKeys";
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import { injectStrict } from "@/utils/vue";

const card = injectStrict(cardKey);
</script>

<template>
  <BaseTooltip v-if="card.almId" :key="card.almId">
    <template #content>{{ card.almId }}</template>
    <a
      class="icon-button"
      :href="card.almIssueUrl"
      target="_blank"
      :aria-label="$t('label.actionMenu.almIssue')"
    >
      <SvgIcon :name="getAlmInfo().icon" class="icon" />
    </a>
  </BaseTooltip>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";

.icon-button {
  display: inline-flex;
  padding: 8px;

  :deep(path) {
    fill-opacity: 1;
  }

  &:hover {
    background-color: colors.$background-alpha-hover;
    color: colors.$icon;
  }
}
</style>
